export const TRAINING_DEMO_PAGE = '/training-demo';

export function getSafeRedirectPath(path: string | null): string {
  if (!path || !path.startsWith('/') || path.startsWith('//')) {
    return '/';
  }
  return path;
}

export function getLoginUrlWithRedirect(redirectPath: string): string {
  return `/login?redirect=${encodeURIComponent(redirectPath)}`;
}

export function openTrainingDemo(): void {
  window.open(TRAINING_DEMO_PAGE, '_blank');
}

export function goToTrainingOrLogin(navigate: (path: string) => void): void {
  const token = localStorage.getItem('token');
  if (token) {
    openTrainingDemo();
    return;
  }

  const shouldLogin = window.confirm(
    'You need to be logged in to access the training demo. Would you like to login now?'
  );
  if (shouldLogin) {
    navigate(getLoginUrlWithRedirect(TRAINING_DEMO_PAGE));
  }
}
